import { useState } from "react";
import { uniqueId } from "lodash";
import type { MultiSelectOptionType } from "./index";

interface OptionProps {
  onChange: (value: string, checked: boolean) => void;
  option: MultiSelectOptionType;
  selected: boolean;
}

export const Option = ({ option, onChange, selected = false }: OptionProps) => {
  const { label, value } = option;
  const [isChecked, setIsChecked] = useState(selected);
  const id = uniqueId();

  const handleOnChange = () => {
    onChange(value, !isChecked);
    setIsChecked(!isChecked);
  };

  return (
    <>
      <div className="flex h-5 items-center">
        <input
          id={id}
          type="checkbox"
          checked={isChecked}
          onChange={handleOnChange}
          className="size-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className="text-darkest font-medium">
          {label}
        </label>
      </div>
    </>
  );
};
